import { TableHead, TableRow, TableCell, Checkbox, TableSortLabel } from "@mui/material";



import { Fragment } from "react";


/** Presentational section; state and actions remain owned by its parent. */
export default function TableHeader({ canSelect, selected, rows, selectAll, headers, isAsc, setSort, setIsAsc, actions, setting }) {
  return (
<TableHead>
                  <TableRow>
                    {canSelect && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={
                            selected.length > 0 && selected.length < rows.length
                          }
                          checked={
                            rows.length > 0 && selected.length === rows.length
                          }
                          onChange={selectAll}
                        />
                      </TableCell>
                    )}

                    {headers?.map((header, i) => (
                      <Fragment key={header.title + "body"}>
                        {/*    {header.name} */}
                        {header.showInList && !header.showInExtra ? (
                          <>
                            <TableCell
                              colSpan={header.colSpan || 1}
                              sx={{ fontSize: "0.7rem !important" }}
                            >
                              {header.hasOrder ? (
                                <TableSortLabel
                                  sx={{
                                    svg: {
                                      height: "0.6em",
                                      width: "0.6em",
                                    },
                                    fontSize: "0.73rem !important",
                                    "&:hover": {
                                      svg: {
                                        color: "#001ee4!important",
                                      },
                                    },
                                    color: (theme) =>
                                      theme.palette.mode === "light"
                                        ? "#000 !important"
                                        : "#fff  !important",
                                  }}
                                  active={true}
                                  direction={
                                    isAsc[header.name] ? "asc" : "desc"
                                  }
                                  onClick={() => {
                                    var temp = { ...isAsc };
                                    delete temp[header.name];
                                    setSort({
                                      ...temp,
                                      [header.name]: !isAsc[header.name],
                                    });
                                    setIsAsc({
                                      ...isAsc,
                                      [header.name]: !isAsc[header.name],
                                    });
                                  }}
                                >
                                  {header.title}
                                </TableSortLabel>
                              ) : (
                                header.title
                              )}
                            </TableCell>
                          </>
                        ) : (
                          <Fragment key={i + "ss"}>
                            <TableCell
                              sx={{
                                width: "0px !important",
                                padding: "0px !important",
                              }}
                            ></TableCell>
                          </Fragment>
                        )}
                      </Fragment>
                    ))}
                    {actions &&
                      setting?.TableType !== "accordian" &&
                      actions?.map((action) => (
                        <TableCell
                          sx={{ fontSize: "0.7rem !important" }}
                          key={action.title + "action"}
                        >
                          {action?.title}
                        </TableCell>
                      ))}
                    {setting?.TableType === "accordian" ? (
                      <TableCell></TableCell>
                    ) : (
                      <></>
                    )}
                  </TableRow>
                </TableHead>
  );
}
